import { createAction, createSlice } from "@reduxjs/toolkit";
import { editingCourseActions } from "./editingCourse";

const addAssignmentSlice = createSlice({
  name: "addAssignment",
  initialState: {
    data: null,
    processingList: [{ id: null, processing: false, isSuccess: null }],
  },
  reducers: {
    pending(state, action) {
      const { assignmentId } = action.payload;
      state.processingList.push({
        id: assignmentId,
        processing: true,
      });
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { assignmentId } = action.payload;
      const assignmentIndex = state.processingList.findIndex(
        (assignment) => assignment.id == assignmentId
      );
      state.processingList[assignmentIndex].processing = false;
      state.processingList[assignmentIndex].isSuccess = true;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      const { assignmentId } = action.payload;
      const assignmentIndex = state.processingList.findIndex(
        (assignment) => assignment.id == assignmentId
      );
      state.processingList[assignmentIndex].processing = false;
      state.processingList[assignmentIndex].isSuccess = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = addAssignmentSlice;
const addAssignmentAction = editingCourseActions.addAssignment;

export {
  addAssignmentAction,
  actions as addAssignmentActions,
  reducer as addAssignmentReducer,
};
